import { EmployerFormFields, FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { utilNumberToCurrency } from '../../../../../utils';

export const employerStatementFormFields: Record<keyof EmployerFormFields, FormInput> = {
  employerName: {
    fieldName: 'employerName',
    label: 'Naam werkgever',
    type: 'text',
    tooltip:
      'Vul de volledige naam in van de organisatie waarmee de medewerker de arbeidsovereenkomst heeft (geen handelsnaam).',
    defaultValue: getDefaultValue('employerName')
  },
  employerAddress: {
    fieldName: 'employerAddress',
    label: 'Adres werkgever',
    type: 'text',
    tooltip: 'Vul het adres van de organisatie in. Een postbusnummer is niet toegestaan.',
    defaultValue: getDefaultValue('employerAddress')
  },
  employerPostCode: {
    fieldName: 'employerPostCode',
    label: 'Postcode',
    placeHolder: '1234 AB',
    type: 'text',
    defaultValue: getDefaultValue('1234 AB')
  },
  employerPlace: {
    fieldName: 'employerPlace',
    label: 'Plaats',
    type: 'text',
    tooltip: 'De postcode moet horen bij het adres.',
    defaultValue: getDefaultValue('employerPlace')
  },
  werkgeverskvk: {
    fieldName: 'werkgeverskvk',
    label: 'Kamer van Koophandel (KvK)',
    type: 'number',
    defaultValue: getDefaultValue('12345678')
  },
  /*werknemersaanspreekvorm: {
    fieldName: 'werknemersaanspreekvorm',
    label: 'Aanspreekvorm',
    type: 'radio',
    tooltip: 'Indien van toepassing, vul hier ook de meisjesnaam van de werknemer in.',
    defaultValue: getDefaultValue('Man')
  },*/
  werknemersnaam: {
    fieldName: 'werknemersnaam',
    label: 'Naam werknemer',
    type: 'text',
    defaultValue: getDefaultValue('werknemersnaam')
  },
  werknemersadres: {
    fieldName: 'werknemersadres',
    label: 'Adres werknemer',
    type: 'text',
    defaultValue: getDefaultValue('werknemersadres')
  },
  werknemerspostcode: {
    fieldName: 'werknemerspostcode',
    label: 'Postcode',
    placeHolder: '1234 AB',
    type: 'text',
    defaultValue: getDefaultValue('123456789')
  },
  werknemerswoonplaats: {
    fieldName: 'werknemerswoonplaats',
    label: 'Woonplaats',
    type: 'text',
    defaultValue: getDefaultValue('werknemerswoonplaats')
  },
  werknemersgeboortedatum: {
    fieldName: 'werknemersgeboortedatum',
    label: 'Geboortedatum',
    type: 'date',
    defaultValue: getDefaultValue('1981-09-27')
  },
  werknemersindiensttreding: {
    fieldName: 'werknemersindiensttreding',
    label: 'Datum indiensttreding',
    type: 'date',
    tooltip:
      'De datum van indiensttreding moet overeenkomen met de datum in de arbeidsovereenkomst en op de salarisstrook van de werknemer.',
    defaultValue: getDefaultValue('2010-09-27')
  },
  werknemersfunctie: {
    fieldName: 'werknemersfunctie',
    label: 'Functie',
    type: 'text',
    defaultValue: getDefaultValue('werknemersfunctie')
  },
  werknemersarbeidsvorm: {
    fieldName: 'werknemersarbeidsvorm',
    label: 'Arbeidsvorm',
    type: 'radio',
    defaultValue: getDefaultValue('Bepaalde tijd')
  },
  werknemersuitdiensttreding: {
    fieldName: 'werknemersuitdiensttreding',
    label: 'Einddatum van het contract',
    type: 'date',
    tooltip:
      'Bij een arbeidsovereenkomst voor bepaalde tijd of een tijdelijk dienstverband is van belang dat de vermelde begin- en einddatum overeenkomen met de data in de arbeidsovereenkomst',
    defaultValue: getDefaultValue('2024-09-27')
  },
  werknemersflexibelarbeidsvorm: {
    fieldName: 'werknemersflexibelarbeidsvorm',
    label: 'Flexibele arbeidsvorm',
    type: 'text',
    hint: '(bijv. uitzend-, inval- of oproepkracht (inclusief fase))',
    defaultValue: getDefaultValue('werknemersflexibelarbeidsvorm')
  },
  heeftproeftijd: {
    fieldName: 'heeftproeftijd',
    label: 'Is er sprake van een proeftijd?',
    type: 'radio',
    defaultValue: getDefaultValue('false')
  },
  proeftijdverstreken: {
    fieldName: 'proeftijdverstreken',
    label: 'Is de proeftijd verstreken?',
    type: 'radio',
    defaultValue: getDefaultValue('true')
  },
  dienstverbandbinnenkortbeeindigen: {
    fieldName: 'dienstverbandbinnenkortbeeindigen',
    label:
      'Is er een reorganisatie of maatregel aangekondigd die het dienstverband of het inkomen mogelijk raken of zijn er voornemens het dienstverband binnenkort te beëindigen?',
    type: 'radio',
    defaultValue: getDefaultValue('true')
  },
  toelichtingDienstverbandBeeindiging: {
    fieldName: 'toelichtingDienstverbandBeeindiging',
    label:
      'Zo ja, licht toe wat de impact hiervan is op het dienstverband of inkomen van de medewerker',
    type: 'textarea',
    hint: 'max 350 tekens',
    defaultValue: getDefaultValue('toelichtingDienstverbandBeeindiging')
  },
  isDirecteurAandeelhouder: {
    fieldName: 'isDirecteurAandeelhouder',
    label: 'Directeur / aandeelhouder',
    type: 'radio',
    defaultValue: getDefaultValue('true')
  },
  percentageAandelen: {
    fieldName: 'percentageAandelen',
    label: 'Percentage aandelen',
    type: 'percentage',
    defaultValue: getDefaultValue('27,90')
  },
  verklaringVoortzettingDienstverband: {
    fieldName: 'verklaringVoortzettingDienstverband',
    label:
      'Bij gelijkblijvend functioneren en ongewijzigde bedrijfsomstandigheden wordt de arbeidsovereenkomst voor bepaalde tijd bij beëindigen daarvan opgevolgd door een arbeidsovereenkomst voor onbepaalde tijd',
    type: 'radio',
    defaultValue: getDefaultValue('jaBepaaldeTijd')
  },
  jaBepaaldeTijd: {
    fieldName: 'jaBepaaldeTijd',
    label: 'Voor hoeveel maanden wordt de arbeidsovereenkomst voortgezet? ',
    type: 'number',
    defaultValue: getDefaultValue('12')
  },
  wordenDeArbeidsvoorwaardenGewijzigd: {
    fieldName: 'wordenDeArbeidsvoorwaardenGewijzigd',
    label: 'Worden bij vernieuwing de arbeidsvoorwaarden gewijzigd, zo ja, licht toe hoe:',
    type: 'radio',
    defaultValue: getDefaultValue('false')
  },
  toelichtingwordenDeArbeidsvoorwaardenGewijzigd: {
    fieldName: 'toelichtingwordenDeArbeidsvoorwaardenGewijzigd',
    label: 'Toelichting vernieuwing de arbeidsvoorwaarden gewijzigd:',
    type: 'textarea',
    hint: 'max 350 tekens',
    defaultValue: getDefaultValue('toelichtingwordenDeArbeidsvoorwaardenGewijzigd')
  },
  verklaringvoortzettingdienstverbandnaam: {
    fieldName: 'verklaringvoortzettingdienstverbandnaam',
    label: 'Naam ondertekenaar',
    type: 'text',
    defaultValue: getDefaultValue('verklaringvoortzettingdienstverbandnaam')
  },
  jaarsalaris: {
    fieldName: 'jaarsalaris',
    label: 'Bruto Jaarsalaris',
    type: 'currency',
    tooltip:
      'Het bruto jaarsalaris moet gelijk zijn aan 12 maal het salaris op de ingeleverde salarisstrook. Of 13 maal als er sprake is van een vierwekelijks salaris. Is er rekening gehouden met een toekomstige salarisstijging op de werkgeversverklaring, dan is een verklaring nodig op briefpapier van de organisatie met hierin vermeld wanneer de stijging ingaat en dat de salarisstijging herroeppelijk is. Vul het werkelijke salaris in. Bij een parttime baan vul hier het salaris voor een parttimer in en niet het fulltime salaris.',
    hint: '(basissalaris excl. overwerk e.d.)',
    defaultValue: getDefaultValue(utilNumberToCurrency(parseFloat('1.50'), true))
  },
  vakantieToeslag: {
    fieldName: 'vakantieToeslag',
    label: 'Vakantietoeslag',
    type: 'currency',
    tooltip:
      'De vakantietoeslag bereken je zoals vermeld in de arbeidsovereenkomst van de werknemer. Bijvoorbeeld: 8% van het bruto jaarsalaris. Krijg de werknemer vakantiebonnen, vul dan de totale waarde van de bonnen over de afgelopen 12 maanden in.',
    defaultValue: getDefaultValue(utilNumberToCurrency(parseFloat('1100'), true))
  },
  onregelmatigheidsToeslag: {
    fieldName: 'onregelmatigheidsToeslag',
    label: 'Onregelmatigheidstoeslag',
    type: 'currency',
    tooltip:
      'Is er structureel sprake van onregelmatigheidstoeslag, provisie en/of overwerk, vul dan de totale uitkering van de afgelopen 12 maanden in. Structureel wil zeggen dat het algemeen bekend is dat onregelmatigheid, provisie en/of overwerk bij de functie past. Er zijn banken die toestaan dat met een groter aantal maanden gerekend mag worden. Je medewerker of de hypotheekadviseur zal dit dan aan je doorgeven.',
    defaultValue: getDefaultValue(utilNumberToCurrency(parseFloat('1200'), true))
  },
  vaste13eMaand: {
    fieldName: 'vaste13eMaand',
    label: 'Vaste 13e maand',
    type: 'currency',
    tooltip:
      'Een vaste uitkering, zoals een 13e maand of eindejaarsuitkering, is vast als deze onvoorwaardelijk in de arbeidsovereenkomst is opgenomen.',
    defaultValue: getDefaultValue(utilNumberToCurrency(parseFloat('1300'), true))
  },
  provisie: {
    fieldName: 'provisie',
    label: 'Provisie',
    type: 'currency',
    tooltip:
      'Is er structureel sprake van onregelmatigheidstoeslag, provisie en/of overwerk, vul dan de totale uitkering van de afgelopen 12 maanden in. Structureel wil zeggen dat het algemeen bekend is dat onregelmatigheid, provisie en/of overwerk bij de functie past. Er zijn banken die toestaan dat met een groter aantal maanden gerekend mag worden. Je medewerker of de hypotheekadviseur zal dit dan aan je doorgeven.',
    defaultValue: getDefaultValue('')
  },
  eindejaarsUitkering: {
    fieldName: 'eindejaarsUitkering',
    label: 'Vaste eindejaarsuitkering',
    type: 'currency',
    tooltip:
      'Een vaste uitkering, zoals een 13e maand of eindejaarsuitkering, is vast als deze onvoorwaardelijk in de arbeidsovereenkomst is opgenomen.',
    defaultValue: getDefaultValue(utilNumberToCurrency(parseFloat('1400'), true))
  },
  overwerk: {
    fieldName: 'overwerk',
    label: 'Overwerk',
    type: 'currency',
    tooltip:
      'Is er structureel sprake van onregelmatigheidstoeslag, provisie en/of overwerk, vul dan de totale uitkering van de afgelopen 12 maanden in. Structureel wil zeggen dat het algemeen bekend is dat onregelmatigheid, provisie en/of overwerk bij de functie past. Er zijn banken die toestaan dat met een groter aantal maanden gerekend mag worden. Je medewerker of de hypotheekadviseur zal dit dan aan je doorgeven.',
    defaultValue: getDefaultValue(utilNumberToCurrency(parseFloat('1500'), true))
  },
  extraFlexibleBudget: {
    fieldName: 'extraFlexibleBudget',
    label: 'Structureel flexibel budget',
    type: 'currency',
    tooltip: 'Dit is vrij besteedbaar <b>en</b> alleen geldelijk uit te keren',
    defaultValue: getDefaultValue(utilNumberToCurrency(parseFloat('1600'), true))
  },
  incomeCustom1Title: {
    fieldName: 'incomeCustom1Title',
    label: 'Overig',
    type: 'text',
    tooltip:
      'Is er structureel sprake van onregelmatigheidstoeslag, provisie en/of overwerk, vul dan de totale uitkering van de afgelopen 12 maanden in. Structureel wil zeggen dat het algemeen bekend is dat onregelmatigheid, provisie en/of overwerk bij de functie past. Er zijn banken die toestaan dat met een groter aantal maanden gerekend mag worden. Je medewerker of de hypotheekadviseur zal dit dan aan je doorgeven.',
    defaultValue: getDefaultValue('incomeCustom1Title')
  },
  incomeCustom1Amount: {
    fieldName: 'incomeCustom1Amount',
    label: 'Bedrag',
    type: 'currency',
    defaultValue: getDefaultValue(utilNumberToCurrency(parseFloat('1234567.50'), true))
  },
  incomeCustom2Title: {
    fieldName: 'incomeCustom2Title',
    label: 'Overig',
    type: 'text',
    tooltip:
      'Is er structureel sprake van onregelmatigheidstoeslag, provisie en/of overwerk, vul dan de totale uitkering van de afgelopen 12 maanden in. Structureel wil zeggen dat het algemeen bekend is dat onregelmatigheid, provisie en/of overwerk bij de functie past. Er zijn banken die toestaan dat met een groter aantal maanden gerekend mag worden. Je medewerker of de hypotheekadviseur zal dit dan aan je doorgeven.',
    defaultValue: getDefaultValue('incomeCustom2Title')
  },
  incomeCustom2Amount: {
    fieldName: 'incomeCustom2Amount',
    label: 'Bedrag',
    type: 'currency',
    defaultValue: getDefaultValue(utilNumberToCurrency(12345678, true))
  },
  heeftOnderhandseLening: {
    fieldName: 'heeftOnderhandseLening',
    label: 'Is door u een onderhandse lening aan de werknemer verstrekt?',
    type: 'radio',
    defaultValue: getDefaultValue('true')
  },
  ingangsdatumOnderhandseLening: {
    fieldName: 'ingangsdatumOnderhandseLening',
    label: 'Ingangsdatum lening',
    placeHolder: 'dd-mm-jjjj',
    type: 'date',
    defaultValue: getDefaultValue('2026-12-30')
  },
  hoofdsomOnderhandseLening: {
    fieldName: 'hoofdsomOnderhandseLening',
    label: 'Hoofdsom',
    type: 'currency',
    defaultValue: getDefaultValue(utilNumberToCurrency(123123, true))
  },
  jaarlastOnderhandseLening: {
    fieldName: 'jaarlastOnderhandseLening',
    label: 'Maandlast',
    type: 'currency',
    defaultValue: getDefaultValue(utilNumberToCurrency(123456789, true))
  },
  looptijdOnderhandseLening: {
    fieldName: 'looptijdOnderhandseLening',
    label: 'Looptijd (maanden)',
    type: 'number',
    defaultValue: getDefaultValue('12')
  },
  heeftLoonbeslag: {
    fieldName: 'heeftLoonbeslag',
    label: 'Is er sprake van loonbeslag of looncessie?',
    type: 'radio',
    defaultValue: getDefaultValue('false')
  },
  einddatumLoonbeslag: {
    fieldName: 'einddatumLoonbeslag',
    label: 'Einddatum loonbeslag',
    type: 'date',
    defaultValue: getDefaultValue('2026-02-02')
  },
  maandlastPerMaandLoonbeslag: {
    fieldName: 'maandlastPerMaandLoonbeslag',
    label: 'Maandlast',
    type: 'currency',
    defaultValue: getDefaultValue(utilNumberToCurrency(123456789, true))
  },
  naamOndertekenaar: {
    fieldName: 'naamOndertekenaar',
    label: 'Naam ondertekenaar',
    type: 'text',
    defaultValue: getDefaultValue('naamOndertekenaar')
  },
  getekendTe: {
    fieldName: 'getekendTe',
    label: 'Getekend te',
    type: 'text',
    defaultValue: getDefaultValue('getekendTe')
  },
  datumOndertekening: {
    fieldName: 'datumOndertekening',
    label: 'Datum ondertekening',
    type: 'date',
    defaultValue: getDefaultValue('2024-01-01')
  },
  naamContactpersoon: {
    fieldName: 'naamContactpersoon',
    label: 'Naam contactpersoon',
    type: 'text',
    defaultValue: getDefaultValue('naamContactpersoon')
  },
  telefoonnummerContactpersoon: {
    fieldName: 'telefoonnummerContactpersoon',
    label: 'Telefoonnummer contactpersoon',
    type: 'text',
    defaultValue: getDefaultValue('0612345678')
  }
};
